import { render, staticRenderFns } from "./SafetyDirector.vue?vue&type=template&id=35b85219&scoped=true&"
import script from "./SafetyDirector.vue?vue&type=script&lang=js&"
export * from "./SafetyDirector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b85219",
  null
  
)

export default component.exports